import React, {Component} from 'react';
import { BrowserRouter as Router, Route, Link, Redirect, NavLink, HashRouter } from "react-router-dom";
import CKEditor from "react-ckeditor-component";
import Header from './../../Header';
import HeaderMob from './../../HeaderMob';
import $ from 'jquery';
        import CryptoJS from 'crypto-js';
        import config from 'react-global-configuration';
class EditNote extends Component {
constructor(props){
    super(props);
                var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
                var localdata = has_local_data?this.decrypt(localStorage.getItem('encdata'), 0):'';
    this.state = {
                userEmail: has_local_data?localdata.user_email:'',
                        userName:has_local_data?localdata.user_name:'',
                        userAuthKey:has_local_data?localdata.user_key:'',
                        apiUrl:this.decryptconfigdata('apiUrl'),
                        userId:has_local_data?localdata.user_id:'',
        notedata:'',
        editnote:localStorage.getItem('ticket_note'),
        message:'',
        imageupload:1
    }
        this.ckOnChange = this.ckOnChange.bind(this);
}
 
        decryptconfigdata(configkey){
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
                var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
                var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
                iv
                });
                var plaintext = bytes.toString(CryptoJS.enc.Utf8);
                return plaintext;
        }
  
        decrypt(findresponse, flg){
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
                var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
                var res = flg ? findresponse.encdata : findresponse;
                var bytes = CryptoJS.AES.decrypt(res, key, {
                iv
                });
                var plaintext = bytes.toString(CryptoJS.enc.Utf8);
                return JSON.parse(plaintext);
        }
         rawjsonparse(findresponse, flg) {
        return findresponse;
    }
  ckOnChange(evt){
      //console.log("onChange fired with event info: ", evt);
    var ckContent = evt.editor.getData();
    this.setState({
        editnote: ckContent
    })
    console.log(this.state.editnote);
  }

  fileSelecthandler = (event) => {
    this.setState({selectedFile:event.target.files[0]});
  }
  updateTicket(){
        document.getElementById("add_note").innerHTML = "Sending....";
   let img = document.getElementById('fileInput').files.length;
   const fd = new FormData;
                if (img > 0){
  for (var x = 0; x < img; x++) {
       fd.append("image[]", document.getElementById('fileInput').files[x]);
   }
  }
  document.getElementById("add_note").disabled = true;
   fd.append('ticket_inputs', JSON.stringify(this.state));
                fetch(this.state.apiUrl + '/TicketRest/updateNoteTicket/id/' + this.props.match.params.noteId + '/userAuthKey/' + this.state.userAuthKey, {
       method: 'POST',
       dataType: 'json',
       body: fd,
   })
                .then((Response) => Response.json())
                .then((findresponse) =>
    {
                findresponse = this.rawjsonparse(findresponse, 1);
        document.getElementById("add_note").disabled = false;
                        document.getElementById("add_note").innerHTML = "update";
                        if (findresponse.code == 200){
        this.setState({
            message:findresponse.msg,
            ticketid:findresponse.ticketid
            
        })
         //window.location.href = '/ticket/viewTicket/id/' + this.state.ticketid;
         this.props.history.push('/ticket/viewTicket/id/' + this.state.ticketid);
                } else{
        this.setState({message:findresponse.msg}) 
     }
    }) 
  }
  getnoteDetails(){
        fetch(this.state.apiUrl + '/TicketRest/EditNote/id/' + this.props.match.params.noteId + '/userAuthKey/' + this.state.userAuthKey)
                .then((Response) => Response.json())
                .then((findresponse) =>
    {
                findresponse = this.rawjsonparse(findresponse, 1);
        this.setState({
            //editnote:findresponse.notedetails,
            ticket_id:findresponse.ticket_id,
            attachment:findresponse.attachment,
            attachment_url:findresponse.attachment_url,
            assigned_to:findresponse.assigned_to,
        })
     
       // alert(this.state.editnote);
       // this.setState({ticketid:findresponse.ticketid})
        //window.location.href = '/viewTicket/' + this.state.ticket.id;
    }) 
  }
 
        delteimage(s3url, img){
     // alert(img);
        if (window.confirm('Are you sure to delete?')) {
        fetch(this.state.apiUrl + '/TicketRest/deletenoteImage/note_id/' + this.props.match.params.noteId + '/id_ticket/' + this.state.ticket_id + '/image/' + img + '/userAuthKey/' + this.state.userAuthKey + '/userid/' + this.state.userId + '/username/' + this.state.userName)
                .then((Response) => Response.json())
                .then((findresponse) =>
    {
        console.log(findresponse);
        this.getnoteDetails();
    }) 
    }
  }
componentWillMount()
{
   
    document.title = "Intranet | Edit Note";
                        if (!localStorage.getItem('userLogin')){
        this.setState({redirect:true});
      }
    this.getnoteDetails();
    $(document).ready(function () {
        $('.upload_btn label').click(function(){
            $('.upload_btn .inputfile').click();
        });
                        $('.inputfile').each(function()
    {
                var $input = $(this),
                        $label = $input.next('label'),
            labelVal = $label.html();
                        $input.on('change', function(e)
        {
            var fileName = '';
                                if (this.files && this.files.length > 1)
                                fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);
                                else if (e.target.value)
                                fileName = e.target.value.split('\\').pop();
                                if (fileName)
                                $label.find('span').html(fileName);
            else
                                $label.html(labelVal);
        });
        // Firefox bug fix
        $input
                        .on('focus', function(){ $input.addClass('has-focus'); })
                        .on('blur', function(){ $input.removeClass('has-focus'); });
    });
});
}
    render(){
        if (this.state.redirect) {
            return (
              <Redirect to={'/login'} />
              
            )
            
          }
     
        //alert(x);
        return(
           <div>
               <Header brecum_name="Support" brecum_page="Ticket Detail" editnote={this.state.editnote}/>
               <div class="right_col">
			<div class="intranet_body">
            <div class="title mob"><HeaderMob page_name="Update Note"/></div>
                <div class="top-row-form">
					<div class="form-group">
					  <label>Note<span class="star">*</span></label>
                      {/* <textarea  class="ckeditor" id="notedata" name="notedata" value={this.state.editnote} onChange={this.onChangeNote}></textarea> */}
                      <CKEditor 
                            activeClass="p10" 
                           content={this.state.editnote} 
                           //value={this.state.editnote}
                            events={{
                            "change": this.ckOnChange
                            }}
                            />
                    </div>
                    <div class="details_des">
                            <span class="color-sky">
                            {
                                this.state.attachment ? this.state.attachment.split(",").map(place => 
                    <div class="note_wrap" /*onClick={() => this.showImage(this.state.attachment_url, place)}*/> {place} <div className="details_des delete">
                            <span  class="color-red" onClick={() => this.delteimage(this.state.attachment_url, place)} >
                                        <i class="fa fa-trash"></i>
                                    </span>
                                </div> 
                                </div>
                            ) : ""
                            }
                            </span>
                    </div>
                <div class="upload">
                <label>Add Attachment :</label>
					<div class="upload_btn">
						<input type="file" name="file-1[]" id="fileInput" class="inputfile inputfile-1" data-multiple-caption="{count} files selected" multiple/>
						<label for="file-1">
							<i class="fa fa-plus hidden-sm" aria-hidden="true"></i>
							<span>Choose file</span>
							<i class="fa fa-cloud-upload-alt hidden-md" aria-hidden="true"></i>
						</label>
					</div>
				</div>
            <button   type="submit" name="add_note" id="add_note" className="btn btn-sky mob-btn" onClick={() => this.updateTicket()}>Update</button>
            <Link to={'/ticket/viewTicket/id/' + this.state.ticket_id} name={"max"}> <button  className="btn btn-blue hidden-sm" >Back</button></Link>
            
              <div className="clear"></div>
				</div>
              </div>
              
              <span style={{color: "red"}}>{this.state.message}</span>
            </div>
        </div>
  
        )
    }
}
export default EditNote;


// WEBPACK FOOTER //
// ./src/components/support/EditNote.js